import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import useOffsetSize from '@Hooks/useOffsetSize';

import { ContextMenu, Item } from '@Components/Common/ContextMenu';
import Stepper from '@Components/Common/Stepper';
import TX from '@Components/Common/Text';

const ChangeStatusContextMenu = ({
  targetRef,
  isContextMenuVisible,
  CHANGE_STATUS_CONTEXT_MENU_ITEMS,
  changeStatus,
}) => {
  const { left, top } = useOffsetSize(targetRef, isContextMenuVisible);

  return (
    <ContextMenu position={{ left, top: top + 36 }} style={{ width: '180px', padding: '4px 0px' }}>
      {CHANGE_STATUS_CONTEXT_MENU_ITEMS.map(({ type, title, min, max, Icon, onClick }) => {
        const count = changeStatus[type];
        return (
          <Item key={type} isHoverStyleNeeded={false} style={{ padding: '4px 8px' }}>
            <ContextMenuLeftContainer>
              <ContextMenuIconContainer>{Icon}</ContextMenuIconContainer>
              <ContextMenuItemText>{title}</ContextMenuItemText>
            </ContextMenuLeftContainer>

            <Stepper min={min} max={max} count={count} onChange={onClick} />
          </Item>
        );
      })}
    </ContextMenu>
  );
};

ChangeStatusContextMenu.propTypes = {
  targetRef: PropTypes.shape({
    current: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
  }),
  isContextMenuVisible: PropTypes.bool.isRequired,
  CHANGE_STATUS_CONTEXT_MENU_ITEMS: PropTypes.arrayOf(PropTypes.object).isRequired,
  changeStatus: PropTypes.objectOf(PropTypes.number).isRequired,
};

ChangeStatusContextMenu.defaultProps = {
  targetRef: undefined,
};

const FlexAlignCenterDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconCSS = css`
  width: 16px;
  height: 16px;
`;

const ContextMenuLeftContainer = styled(FlexAlignCenterDiv)`
  padding: 4px;
`;

const StyledIconWrapper = styled(FlexAlignCenterDiv)`
  ${IconCSS}
`;

const ContextMenuIconContainer = styled(StyledIconWrapper)`
  margin-right: 6px;
`;

const ContextMenuItemText = styled(TX.FootnoteM)`
  width: 44px;
`;

export default ChangeStatusContextMenu;
